import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import styles from './styles/Pagination.module.css';

const range = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => start + i);

const Pagination = ({ page, limit, total, onChange }) => {
    const totalPages = Math.max(1, Math.ceil(total / limit));
    const canPrev = page > 1;
    const canNext = page < totalPages;

    const pages = totalPages <= 7
        ? range(1, totalPages)
        : page <= 4
            ? [...range(1, 5), '...', totalPages]
            : page >= totalPages - 3
                ? [1, '...', ...range(totalPages - 4, totalPages)]
                : [1, '...', page - 1, page, page + 1, '...', totalPages];

    return (
        <div className={styles.wrapper}>
            <button className={`${styles.btn} ${!canPrev ? styles.disabled : ''}`.trim()} disabled={!canPrev} onClick={() => onChange(page - 1)}>
                <ChevronLeft size={16} />
            </button>
            {pages.map((p, idx) => (
                typeof p === 'number' ? (
                    <button
                        key={idx}
                        className={`${styles.num} ${p === page ? styles.numActive : ''}`.trim()}
                        onClick={() => onChange(p)}
                    >
                        {p}
                    </button>
                ) : (
                    <span key={idx} className={styles.num} style={{ cursor: 'default' }}>{p}</span>
                )
            ))}
            <button className={`${styles.btn} ${!canNext ? styles.disabled : ''}`.trim()} disabled={!canNext} onClick={() => onChange(page + 1)}>
                <ChevronRight size={16} />
            </button>
        </div>
    );
};

Pagination.propTypes = {
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default memo(Pagination);
